/**
 * Autoglossonyms — a language's name written in that language — keyed by caption-protocol short
 * code.
 *
 * Lives in shared/ because this table has already drifted once: two copies of a language list
 * disagreed and the kiosk rendered raw codes like "hmn" instead of "Hmong" (AB#7232). Extend this,
 * do not fork it.
 */
const NATIVE_NAMES: Readonly<Record<string, string>> = {
  ar: "العربية",
  de: "Deutsch",
  es: "Español",
  fa: "فارسی",
  fil: "Tagalog",
  fr: "Français",
  he: "עברית",
  hmn: "Hmoob",
  ko: "한국어",
  prs: "دری",
  pt: "Português",
  ru: "Русский",
  so: "Soomaali",
  ur: "اردو",
  vi: "Tiếng Việt",
  "zh-hans": "中文",
  "zh-hant": "中文"
};

// "prs" (Dari) is Perso-Arabic and RTL. Caption-only, so no Listen button reveals a missing
// flag — the only symptom is caption text running the wrong way. AB#10190.
const RTL_LANGUAGES: ReadonlySet<string> = new Set([
  "ar",
  "fa",
  "he",
  "ur",
  "prs"
]);

export function nativeLanguageName(
  shortCode: string,
  fallbackName: string
): string {
  return NATIVE_NAMES[shortCode.toLowerCase()] ?? fallbackName;
}

export function isRightToLeft(shortCode: string): boolean {
  return RTL_LANGUAGES.has(shortCode.toLowerCase());
}
